import React from 'react';
import { instagramUrl, kickstarterUrl, tiktokUrl, youtubeUrl } from './constants/Constants';

function HeaderInGame() {
    const logoBlack = require("./images/logoBlack.png");
    const instagram = require("./images/instagram.png");
    const youtube = require("./images/youtube.png");
    const tiktok = require("./images/tiktok.png");

    const handleKickstarterClick = () => {
        window.open(kickstarterUrl, '_blank');
    }

    const handleInstagramClick = () => {
        window.open(instagramUrl, '_blank');
    }

    const handleYoutubeClick = () => {
        window.open(youtubeUrl, '_blank');
    }

    const handleTiktokClick = () => {
        window.open(tiktokUrl, '_blank');
    }

    return (
        <div className="headerInGameWrapper">
            <div className="headerInGameLeft">
                <img className="headerInGameLogo" src={logoBlack} alt="logo"/>
                <div className="headerInGameKickstarter" tabIndex={0} onClick={handleKickstarterClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleKickstarterClick();
                    }
                }}>
                    KICKSTARTER
                </div>
            </div>
            <div className="headerInGameRight">
            <div className="headerInGameInstagram" tabIndex={0} onClick={handleInstagramClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleInstagramClick();
                    }
                }}>
                    <img className="headerInGameInstagramIcon" src={instagram} alt="instagram"/>
                </div>
                <div className="headerInGameYoutube" tabIndex={0} onClick={handleYoutubeClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleYoutubeClick();
                    }
                }}>
                    <img className="headerInGameYoutubeIcon" src={youtube} alt="youtube"/>
                </div>
                <div className="headerInGameTiktok" tabIndex={0} onClick={handleTiktokClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleTiktokClick();
                    }
                }}>
                    <img className="headerInGameTiktokIcon" src={tiktok} alt="tiktok"/>
                </div>
            </div>
        </div>
    );
};

export default HeaderInGame;